import { ptlEnvs } from "../../comn";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_DOC_CHNL_MGMT_INFO,
    SG_DOC_TRSC_INFO_LIST,
} from "@/tra/tancis/ptli/elctdoc/chnl/services/PtliChnlMgmtService";
import { PTLI0705004Q } from "@/tra/tancis/ptli/elctdoc/chnl/PTLI0705004Q";

/*
 * Insert Channel
 * !== 채널 등록 ==!
 */
export const PTLI0705002S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0046", "auth_ptli0047"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const [sndrcvDvnCd, setSndrcvDvnCd] = useState();
    const [trgtTpCd, setTrgtTpCd] = useState();
    const [govesbUseYn, setGovesbUseYn] = useState<boolean>(false);
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0069" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "COM0080" }, // 채널 신청 진행상태 코드
            { area: "comnCd", comnCd: "COM0064" }, // 활성화 여부 코드
            { area: "comnCd", comnCd: "COM0077" }, // 송수신 구분 코드
            { area: "comnCd", comnCd: "COM0071" }, // 연계 프로토콜 코드
            { area: "comnCd", comnCd: "COM0070" }, // 송수신 유형 코드
            { area: "comnCd", comnCd: "COM0083" }, // 연계인증 유형 코드
            { area: "coDclaCd" }, // 업체 신고 코드
            { area: "cntyCd" }, // 국가 코드
        ],
    });
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        docChnlForm: useForm({
            defaultSchema: SF_DOC_CHNL_MGMT_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        docBoxTrscList: useGrid({
            defaultSchema: SG_DOC_TRSC_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Create Channel !== 채널 등록 ==!
        insertElctDocChnl: useFetch({
            api: (data) => APIS.insertElctDocChnl({ ...data }),
            onSuccess: (res) => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        const intfChnlId = res.chnlInfo.content.intfChnlId;

                        navigate(`${URLS.ptli0705003s}/${intfChnlId}`);
                    },
                    close: false,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.docChnlForm.setErrors(error.response.data.errors);
                }

                const { errorCode, errorMessage } = error.response.data;

                if (errorCode === "-999") {
                    modal.openModal({
                        content: errorMessage,
                    });

                    return;
                }

                modal.openModal({
                    content: "msg.00006", // An error occurred during processing.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 등록 버튼 클릭 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.docChnlForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            // if(comnUtils.isEmptyArray(grid.docBoxTrscList.getData())) {
            //     // Please select {0}. !== {0} 을(를) 선택하여 주세요. ==!

            //     toast.showToast({ type: "warning", content: t("msg.com.00038", { 0: t("L_TRGT_INTF_CHNL_ID") }) });
            //     return;
            // }

            form.docChnlForm.handleSubmit(
                () => {
                    const data = form.docChnlForm.getValues();
                    const elctDocTrscList = grid.docBoxTrscList.getData();

                    // Setting Transaction List !== 트랜잭션 목록 세팅 ==!
                    data.elctDocTrscList = elctDocTrscList;

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertElctDocChnl.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // on Grid Add Button Click Event Handler !== 그리드 추가 클릭 ==!
        onGridAddBtnClick: () => {
            const modalCallback = (list: any[]) => {
                if (!comnUtils.isEmpty(list)) {
                    list.forEach((item: any) => {
                        const arrRowData = grid.docBoxTrscList.getAddedData();

                        // Add only if data is not in the existing grid !== 기존 그리드에 없는 데이터인 경우에만 추가 ==!
                        if (!comnUtils.isEmptyArray(arrRowData)) {
                            const bExist = arrRowData.some((rowData: any) => {
                                return rowData.intfId === item.intfId;
                            });

                            if (bExist) return;
                        }

                        grid.docBoxTrscList.addRow({ ...item });
                    });
                }

                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "md",
                content: <PTLI0705004Q callback={modalCallback} sndrcvDvnCd={sndrcvDvnCd} />,
            });
        },
        // Delete Transaction list deletion event !== 트랜잭션 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridDocTrscList: () => {
            const seltList: any[] = grid.docBoxTrscList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }

            modal.openModal({
                content: "msg.00103",
                onConfirm: () => {
                    grid.docBoxTrscList.deleteRow("checkbox");
                },
            });
        },
        // Form readOnly processing according to transmission and reception classification !== 송수신 구분에 따른 form readOnly 처리 ==!
        onChangetrgtTpCd: (isNull: boolean) => {},
        // onChangeGovesbUseYn Event Handler !== Govesb 사용여부 변경 이벤트 ==!
        onChangeGovesbUseYn: (value: string) => {
            if (value == "Y") {
                setGovesbUseYn(true);

                if (form.docChnlForm.getValue("trgtTpCd") === "B") {
                    grid.docBoxTrscList.setEdit("cell", "apiCd", true);
                    grid.docBoxTrscList.setEdit("cell", "pshCd", true);
                }
            } else {
                setGovesbUseYn(false);
                grid.docBoxTrscList.setEdit("cell", "apiCd", false);
                grid.docBoxTrscList.setEdit("cell", "pshCd", false);
            }
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // Encourage people to select send/receive first !== 송신/수신 먼저 선택하게 유도 ==!
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_SELC_SNDRCV"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.docChnlForm.schema.trgtTpCd}
                                onChange={(value) => {
                                    form.docChnlForm.clearErrors();

                                    if (comnUtils.isEmpty(trgtTpCd)) {
                                        setTrgtTpCd(value);
                                    } else if (trgtTpCd !== value) {
                                        modal.openModal({
                                            // All entered information will be reset. Do you want to change it?. !== 입력한 정보가 모두 초기화됩니다. 변경하시겠습니까?. ==!
                                            content: "msg.com.00131",
                                            onConfirm: () => {
                                                form.docChnlForm.reset();

                                                form.docChnlForm.setValue("trgtTpCd", value);
                                                setTrgtTpCd(value);
                                            },
                                            onCancel: () => {
                                                form.docChnlForm.setValue("trgtTpCd", trgtTpCd);
                                                setTrgtTpCd(trgtTpCd);
                                            },
                                        });
                                    }

                                    if (value === "B") {
                                        if (form.docChnlForm.getValue("govesbUseYn") === "Y") {
                                            grid.docBoxTrscList.setEdit("cell", "apiCd", true);
                                            grid.docBoxTrscList.setEdit("cell", "pshCd", true);
                                        } else {
                                            grid.docBoxTrscList.setEdit("cell", "apiCd", false);
                                            grid.docBoxTrscList.setEdit("cell", "pshCd", false);
                                        }
                                    }

                                    handler.onChangetrgtTpCd(false);
                                }}
                                defaultValue={"C"}
                            />
                            {trgtTpCd !== "E" && (
                                <Group.Control
                                    {...form.docChnlForm.schema.sndrcvDvnCd}
                                    onChange={(value) => {
                                        form.docChnlForm.clearErrors();

                                        if (comnUtils.isEmpty(sndrcvDvnCd)) {
                                            setSndrcvDvnCd(value);
                                        } else if (sndrcvDvnCd !== value) {
                                            modal.openModal({
                                                // All entered information will be reset. Do you want to change it?. !== 입력한 정보가 모두 초기화됩니다. 변경하시겠습니까?. ==!
                                                content: "msg.com.00131",
                                                onConfirm: () => {
                                                    form.docChnlForm.reset();

                                                    form.docChnlForm.setValue("sndrcvDvnCd", value);
                                                    setSndrcvDvnCd(value);
                                                },
                                                onCancel: () => {
                                                    form.docChnlForm.setValue("sndrcvDvnCd", sndrcvDvnCd);
                                                    setSndrcvDvnCd(sndrcvDvnCd);
                                                },
                                            });
                                        }
                                    }}
                                />
                            )}
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_CHNL_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.intfChnlId} />
                                <Group.Control {...form.docChnlForm.schema.chnlNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.chnlIpAddr} />
                                <Group.Control {...form.docChnlForm.schema.chnlPortValue} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.chnlPrtclNm} defaultValue={"A"} />
                                <Group.Control {...form.docChnlForm.schema.chnlUrlAddr} />
                            </Group.Row>
                            <Group.Row>
                                {/* C : approval */}
                                <Group.Control {...form.docChnlForm.schema.actvtYn} defaultValue={"Y"} />
                                <Group.Control
                                    {...form.docChnlForm.schema.chnlAplyPrcdStatCd}
                                    defaultValue={"C"}
                                    readOnly={true}
                                />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_IFAUTH_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    hidden={trgtTpCd !== "B"}
                                    {...form.docChnlForm.schema.govesbUseYn}
                                    onChange={(value) => {
                                        handler.onChangeGovesbUseYn(value);
                                    }}
                                />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.ifauthTpCd} />
                                <Group.Control {...form.docChnlForm.schema.tknUrl} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.tknId} />
                                <Group.Control {...form.docChnlForm.schema.tknSecrtKeyValue} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.chnlKeyCn} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_USR_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.trgtTin} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cntyCd} defaultValue={"TZ"} />
                                <Group.Control {...form.docChnlForm.schema.coCd} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {trgtTpCd === "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_CPA_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cpaId} />
                                <Group.Control {...form.docChnlForm.schema.cpaCntyCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cpaSndrId} />
                                <Group.Control {...form.docChnlForm.schema.cpaSndrPwd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cpaRcvrId} />
                                <Group.Control {...form.docChnlForm.schema.cpaRcvrPwd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.parnEnpo} />
                                <Group.Control {...form.docChnlForm.schema.parnIp} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.ovstCagYn} />
                                <Group.Control {...form.docChnlForm.schema.ipYn} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.tansadBlckYn} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                {comnUtils.isEmpty(sndrcvDvnCd) && (
                                    <Group.Title title={"T_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                                {sndrcvDvnCd == "A" && (
                                    <Group.Title title={"T_TRMSSN_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                                {sndrcvDvnCd == "B" && (
                                    <Group.Title title={"T_RCPN_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                                {sndrcvDvnCd == "C" && (
                                    <Group.Title title={"T_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                            </Layout.Left>
                            <Layout.Right>
                                {!comnUtils.isEmpty(sndrcvDvnCd) && (
                                    <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                                )}
                                {!comnUtils.isEmpty(sndrcvDvnCd) && (
                                    <Layout.Button
                                        role={"gridDelete"}
                                        onClick={handler.click_Btn_DeleteGridDocTrscList}
                                    />
                                )}
                            </Layout.Right>
                        </Layout>
                        <Group.Section>
                            <Grid {...grid.docBoxTrscList.grid} />
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0705001q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
